import { StaysPropertyForm } from '@/components/features/properties/StaysPropertyForm/StaysPropertyForm'
import {
  PropertiesContext,
  PropertiesContextType,
} from '@/contexts/PropertiesContext'
import {
  Box,
  Card,
  CardHeader,
  Container,
  Heading,
  HStack,
  IconButton,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useContext } from 'react'
import { FiArrowLeft } from 'react-icons/fi'
import { PropertyFormRHF } from '../../components/features/properties/PropertyFormRHF/PropertyFormRHF'
import { usePropertyFormPage } from '../../hooks/usePropertyFormPage'

interface PropertyFormPageProps {
  staysSynced?: boolean
}

const getHeadingText = (staysSynced: boolean, isEditing: boolean) => {
  if (staysSynced) {
    return 'Nova Propriedade Stays'
  }
  return isEditing ? 'Editar Acomodação' : 'Nova Acomodação'
}

const getSubtitleText = (staysSynced: boolean, isEditing: boolean) => {
  if (staysSynced) {
    return 'Preencha os dados para cadasastrar uma nova propriedade stays.'
  }
  return isEditing
    ? 'Atualize as informações da Acomodação'
    : 'Preencha os dados para cadastrar uma nova Acomodação'
}

export function PropertyFormPage({
  staysSynced = false,
}: PropertyFormPageProps) {
  const { selectedStaysProperty } = useContext<
    PropertiesContextType | undefined
  >(PropertiesContext) as PropertiesContextType

  const { property, isEditing, loading, handleSuccess, handleCancel } =
    usePropertyFormPage()

  if (loading) {
    return (
      <Container maxW="container.xl" py={8}>
        <Box display="flex" alignItems="center" justifyContent="center" h="64">
          <Box
            w="8"
            h="8"
            border="2px"
            borderColor="blue.500"
            borderTopColor="transparent"
            borderRadius="full"
            animation="spin 1s linear infinite"
          />
        </Box>
      </Container>
    )
  }

  return (
    <VStack
      spacing={8}
      align="stretch"
      p={4}
      border={1}
      borderColor="gray.200"
      borderRadius="lg"
    >
      {/* Header */}
      <HStack justify="space-between" align="center">
        <HStack
          spacing={4}
          padding={'8px'}
          rounded={'md'}
          bgColor={'var(--chakra-colors-green-500)'}
          w={'full'}
          color={'white'}
        >
          <IconButton
            aria-label="Voltar"
            icon={<FiArrowLeft />}
            onClick={handleCancel}
            variant="ghost"
            size="lg"
            color="white"
            rounded={'full'}
            _hover={{
              bg: 'green.300',
              boxShadow: 'var(--chakra-shadows-sm)',
              translate: 'translateY(-1px)',
            }}
          />
          <Box flexGrow={1}>
            <Heading size="lg" mb={2}>
              {getHeadingText(staysSynced, isEditing)}
            </Heading>
            <Text color="white">{getSubtitleText(staysSynced, isEditing)}</Text>
          </Box>
          {!!selectedStaysProperty && (
            <Card bg={'transparent'} border={'1px'} borderColor={'white'}>
              <CardHeader color={'white'}>
                <Text fontWeight={'bold'}>Propriedade Stays</Text>
                <Text>{selectedStaysProperty.internalname}</Text>
              </CardHeader>
            </Card>
          )}
        </HStack>
      </HStack>

      {/* Form */}
      <Box bg="white" borderRadius="lg" boxShadow="sm" p={8}>
        {staysSynced ? (
          <StaysPropertyForm st_property={property?.st_property} />
        ) : (
          <PropertyFormRHF property={property} onClose={handleSuccess} />
        )}
      </Box>
    </VStack>
  )
}
